const baseRoute = '/c'

const widgetPrefixPath = '/:widget(w\\d+)?'
const providerPrefixPath = '/p/:providerSlug(\\d+-[a-z0-9-_]+)'

const baseRoutePrefixRegex = new RegExp(`^${baseRoute}/`)
const widgetPrefixRegex = new RegExp('^(/w\\d+)')
const providerPrefixRegex = new RegExp('^(/p/\\d+-[a-z0-9-_]+)')
const queryStringRegex = /\?.*$/

const nonProviderRoutes = ['/dashboard', '/404', '/leadmanagementform', '/leadmanagementsuccess', '/leadmanagementerror']

export {
  baseRoute,
  widgetPrefixPath,
  providerPrefixPath,
  baseRoutePrefixRegex,
  widgetPrefixRegex,
  providerPrefixRegex,
  queryStringRegex,
  nonProviderRoutes,
}
